export const backButtonMixin = {
  computed: {
    fromRoute() {
      return this.$store.getters.getPrevRoute;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("updatePrevRoute", from.name);
    });
  },
  methods: {
    /**
     * Handle Back
     * @desc Extends default router back functionality
     * @param {string} fallback - The fallback path if there is no history to use with $router.back(). This is usually the case if the page was visited directly or from another site
     **/
    handleBack(fallback) {
      if (!this.fromRoute) {
        this.$router.push(fallback);
      } else {
        this.$router.back();
      }
    }
  }
};
